module.exports = __webpack_public_path__ + "static/media/cm.d4c6251b.jpg";